// @ts-nocheck
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { css } from "styled-components";

export interface BrandProps {
    logoSmall?: LazyImageProps;
}

export const brandProps: BrandProps = {
    logoSmall: {
        css: css`
            ${x => x.theme.lazyImage.defaultProps?.css}
            img {
                max-width: 150px;
                max-height: 150px;
            }
        `,
    },
};
